module.exports = __webpack_public_path__ + "img/default_image.9bc853f0.svg";